import { render, staticRenderFns } from "./ChatMenu.vue?vue&type=template&id=f4dc4c0c&scoped=true"
import script from "./ChatMenu.vue?vue&type=script&lang=js"
export * from "./ChatMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatMenu.vue?vue&type=style&index=0&id=f4dc4c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dc4c0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
